import angular from 'angular';
import handoverPackSidebar from './handoverPackSidebar';

export default angular
  .module('components.handoverPackSidebar', [])
  .component('handoverPackSidebar', handoverPackSidebar).name;
